// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Servicos_GetByIDResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/servicos/getByID/<id>
 *
 * Returns a single service record. Legacy shape emits the row object directly
 * under `dados`.
 */
import type { Servicos_ServicoRow } from './Servicos_ServicoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Servicos_GetByIDResponseDados = Servicos_ServicoRow;

export type Servicos_GetByIDResponse = ApiResponse<Servicos_GetByIDResponseDados>;

registerResponseContract('Servicos_GetByIDResponse', {
  _nullable:              { type: 'boolean', required: false },
  servico_id:             { type: 'number',  required: true },
  servico_nome:           { type: 'string',  required: true },
  servico_valor_padrao:   { type: 'number',  required: true },
  servicoscategoria_id:   { type: 'string',  required: true },
  servicocategoria_id:    { type: 'string',  required: false },
  servicoscategoria_nome: { type: 'string',  required: false },
  categoria:              { type: 'string',  required: false },
})
